import { MediasLogo } from "../../../Header/components/TopBar/MediasLogo";
import { IconType } from "../../../common/components/icon/IconType";
import { REGISTER_PAGE } from "../../../utils/url/staticUrls";

import classes from "./LinearTeaser.module.less";
import classNames from "classnames";
import { Button } from "~/common/components/Button/Button";
import { Icon } from "~/common/components/icon/Icon";
import { IconSize } from "~/common/components/icon/IconSize";
import { useTranslation } from "react-i18next";

export const LinearTeaser = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className={classNames("scha__lc-summary__lc-register-teaser", classes.root)}>
        <MediasLogo variant={"plus"} className={classes.logo} />
        <div className={classes.divider} />
        <div className={classes.text}>{t("page.linear.summary.register.message")}</div>
        <Button
          className={"scha__lc-summary__lc-register-teaser-button"}
          href={REGISTER_PAGE}
          startIcon={<Icon type={IconType.User} size={IconSize.FONT_20} />}
        >
          {t("page.registerFree.register")}
        </Button>
      </div>
    </>
  );
};
